import { memo, useCallback } from "react";

import type { EcReceiptDetail_ManagementEcPageQuery } from "@/lib/gql/__generated__/graphql";

import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithBackGround,
} from "@/components/features/_layouts";

import { Button } from "@/components/ui/button/button";

import { ManagementECReceiptDetailBaseInfoSection as SectionBaseInfo } from "./section/base-info";
import { ManagementECReceiptDetailVoucherIssuedListSection as SectionVoucherIssuedList } from "./section/voucher-issued-list";
import { useInitialized } from "../../model/use-case/initialized";

type Props = {
	hotelID: string;
	data: EcReceiptDetail_ManagementEcPageQuery;
};

export const ManagementECReceiptDetailPresenter = memo(({ hotelID, data }: Props) => {
	const {
		//
		viewData: { ecReceiptItem, voucherIssuedList },

		onMarkVoucher,
		onResendECReceiptEmail,
	} = useInitialized({ hotelID, data });

	const handleClickPrintPageButton = useCallback(() => {
		window.print();
	}, []);

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader title="ECの詳細" />

			<FeatureIslandMainWithBackGround>
				<div className="flex justify-end print:hidden">
					<Button type="button" onClick={handleClickPrintPageButton} variant="outline">
						印刷
					</Button>
				</div>
				<SectionBaseInfo ecReceiptItem={ecReceiptItem} onResendECReceiptEmail={onResendECReceiptEmail} />
				<SectionVoucherIssuedList voucherIssuedList={voucherIssuedList} onMarkVoucher={onMarkVoucher} />
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
});

ManagementECReceiptDetailPresenter.displayName = "ManagementECReceiptDetailPresenter";
